module.exports = __webpack_public_path__ + "static/media/Betel.7acea00f.png";